// import axiosInstance from "./axiosConfig";

// export const getAllContent = async (params = {}) => {
//   const response = await axiosInstance.get("/content", { params });
//   return response.data;
// };

// export const searchContent = async (params = {}) => {
//   const response = await axiosInstance.get("/content/search", { params });
//   return response.data;
// };


import axiosInstance from "./axiosConfig";

export const getAllContent = async (params = {}) => {
  const response = await axiosInstance.get("/content", { params });
  return response.data;
};

// Search content with robust parameters
export const searchContent = async (params = {}) => {
  const response = await axiosInstance.get("/content/search", { params });
  return response.data;
};

// Search reels API
export const searchReelsApi = async (params = {}) => {
  const response = await axiosInstance.get("/reels/search", { params });
  return response.data;
};